/*************************************************/
/* HOVER EFFECTS                                 */
/*************************************************/

export function hoverEffects() {

    const init = () => {
        document.addEventListener("DOMContentLoaded", function () {
            var contentBoxes = document.querySelectorAll(".content-box__panel-button");
            var imageComponents = document.querySelectorAll(".image-item")

            contentBoxes.forEach(function (contentBox) {
                var button = contentBox.querySelector(".panel-button");
                var image = contentBox.querySelector(".content-box__image-overlay");
                var text = contentBox.querySelector(".content-box__headline");
                var lightText = contentBox.querySelector(".content-box__info--light");
                var darkText = contentBox.querySelector(".content-box__info--dark");

                if (button) {
                    contentBox.addEventListener("mouseover", function () {
                        image.style.opacity = ".3";
                        if (darkText) {
                            text.style.color = "#063a2f90";
                        } else if (lightText) {
                            text.style.color = "#FFFFFF90";
                        }
                    });

                    contentBox.addEventListener("mouseout", function () {
                        image.style.opacity = "0";
                        if (darkText) {
                            text.style.color = "#063a2f";
                        } else if (lightText) {
                            text.style.color = "#FFFFFF";
                        }
                    });
                }
            });

            imageComponents.forEach(function (imageItem) {
                var button = imageItem.querySelector(".panel-button");
                var image = imageItem.querySelector(".image-item__desktop-overlay");
                var textLight = imageItem.querySelector(".image-item__text--desktop-color-light");
                var textDark = imageItem.querySelector(".image-item__text--desktop-color-dark");

                if (button) {
                    button.addEventListener("mouseover", function () {
                        image.style.opacity = ".3";
                        if (textLight) {
                            textLight.style.color = "#FFFFFF90";
                        } else if (textDark) {
                            textDark.style.color = "#063a2f90";
                        }
                    });

                    button.addEventListener("mouseout", function () {
                        image.style.opacity = "0";
                        if (textLight) {
                            textLight.style.color = "#FFFFFF";
                        } else if (textDark) {
                            textDark.style.color = "#063a2f";
                        }
                    });
                }
            });
        });          
    };

    init();
}
